import React from "react";
import { HeartPulse } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SectionToggle, NumInput } from "./shared";

const DEFAULT_HC = { enabled: true, annual_base: 10000, start_age: 65, medical_inflation_rate: 5.5 };

export default function HealthcareSection({ inputs, setInputs, open, onToggle }) {
  const hcOn = inputs.healthcare?.enabled;
  const updateHC = (k, v) => setInputs({ ...inputs, healthcare: { ...inputs.healthcare, [k]: v } });
  const toggleHC = (v) => {
    if (v && !inputs.healthcare) setInputs({ ...inputs, healthcare: { ...DEFAULT_HC } });
    else if (v) updateHC("enabled", true);
    else updateHC("enabled", false);
  };

  return (
    <div>
      <SectionToggle
        testId="toggle-healthcare"
        icon={HeartPulse}
        title="Healthcare shock"
        subtitle="Costs growing faster than general inflation"
        badge={hcOn ? "on" : "off"}
        open={open}
        onToggle={onToggle}
      />
      {open && (
        <div className="pb-5 space-y-4">
          <div className="flex items-center justify-between text-sm">
            <Label className="text-[#1C2B23]">Enable healthcare projections</Label>
            <Switch data-testid="hc-enabled" checked={!!hcOn} onCheckedChange={toggleHC} />
          </div>
          {hcOn && (
            <>
              <NumInput id="hc-base" testid="hc-annual-base" label="Annual cost (today's $)" value={inputs.healthcare.annual_base} onChange={(v) => updateHC("annual_base", v)} prefix="$" step={500} />
              <div className="grid grid-cols-2 gap-3">
                <NumInput id="hc-start" testid="hc-start-age" label="Start age" value={inputs.healthcare.start_age} onChange={(v) => updateHC("start_age", v)} suffix="yrs" />
                <NumInput id="hc-inf" testid="hc-inflation" label="Medical inflation" value={inputs.healthcare.medical_inflation_rate} onChange={(v) => updateHC("medical_inflation_rate", v)} suffix="%" step={0.1} />
              </div>
              <p className="text-[11px] text-[#5C6B62] leading-relaxed">
                Medical costs historically grow ~2-3% faster than CPI. Costs compound from start age until life expectancy.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
